// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  inMemoryPersistence,
  initializeAuth,
  setPersistence,
} from "firebase/auth";
import { initializeFirestore } from "firebase/firestore"; // Importa Firestore
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage"; // Importa Firebase Storage
import { Capacitor } from "@capacitor/core";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDp3djBGu504OhM7uGg1jiA6MsC4ZWQszs",
  authDomain: "fusco-fit-connect-4b731.firebaseapp.com",
  databaseURL: "https://fusco-fit-connect-4b731-default-rtdb.firebaseio.com",
  projectId: "fusco-fit-connect-4b731",
  storageBucket: "fusco-fit-connect-4b731.appspot.com",
  messagingSenderId: "691335746060",
  appId: "1:691335746060:web:868eaf5af62d389727d429",
  measurementId: "G-FL6QKY34E9"
};



const app = initializeApp(firebaseConfig);

// Nel WebView nativo evitiamo IndexedDB: database creati da precedenti versioni
// dell'app possono lasciare Firebase Auth in attesa prima ancora della richiesta
// di login. Sul web manteniamo esplicitamente browserLocalPersistence: oltre a
// preservare il login, rende la stessa sessione disponibile nelle nuove schede.
let auth;
let authPersistenceReady;

if (Capacitor.isNativePlatform()) {
  auth = initializeAuth(app, {
      persistence: [
        browserLocalPersistence,
        browserSessionPersistence,
        inMemoryPersistence,
      ],
    });
  authPersistenceReady = Promise.resolve();
} else {
  auth = getAuth(app);
  authPersistenceReady = setPersistence(auth, browserLocalPersistence).catch((error) => {
    console.error('Impossibile configurare la persistenza locale di Firebase Auth:', error);
  });
}

const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
const functions = getFunctions(app);
const storage = getStorage(app);

export { app, db, auth, authPersistenceReady, functions, storage };
